import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ListItemText from "@material-ui/core/ListItemText";
import KpsListItem from "../../core-elements/KpsListItem";
import { withRouter } from "react-router";
import ListSearchHistoryItems from "../list/ListSearchHistoryItems";
import { withStyles } from "@material-ui/core/styles";
import LinkIcon from "@material-ui/icons/Link";
import moment from "moment";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Link from "@material-ui/core/Link";
import { withTheme } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import { Badge, Tooltip } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const styles = (theme) => ({
  iconSpan: {
    float: "right",
    "& > div": {
      display: "inline-flex",
      marginLeft: "3px",
      marginRight: "3px",
    },
  },
});

export class ItemSearches extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    extendedString: "",
    expanded: false,
  };

  componentDidMount() {
    this.extendedInfo(this.props.settings);
    this.secondaryInfo(this.props.listSettings);
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }

  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      let options =
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.history.SearchHistoryInterface"
          ? this.props.searchHistoryOptions.filter((o) => {
              return (
                o !== "settings_searchhistory_numberOfResults" &&
                o !== "settings_searchhistory_userCount"
              );
            })
          : this.props.searchHistoryOptions;
      if (options) {
        for (let i = 0; i < options.length; i++) {
          settings.push({
            label: options[i],
            order: i,
          });
        }
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  extendedInfo(settings) {
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.searchHistoryOptions.length; i++) {
        settings.push({
          label: this.props.searchHistoryOptions[i],
          order: i,
        });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (setting.label === "settings_searchhistory_numberOfResults" ||
            setting.label === "settings_searchhistory_userCount") &&
            this.props.portlet.objectClass ===
              "com.kpsol.api.apicommon.history.SearchHistoryInterface" ? (
            <></>
          ) : (
            <TableRow>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {this.getSettingInfo(setting)}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString: extendedString });
  }
  render() {
    return (
      <KpsListItem
        isPortlet={this.props.isPortlet}
        preText={this.props.preText}
        provided={this.props.provided}
        onItemClick={this.onItemClick}
        secondaryAction={
          this.props.fullscreen && (
            <IconButton
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                this.props.history.push(
                  `/search/${this.props.data.searchString}`
                );
              }}
            >
              <Tooltip title={"Search"} style={{ cursor: "pointer" }}>
                <SearchIcon />
              </Tooltip>
            </IconButton>
          )
        }
        extendedString={
          <ListSearchHistoryItems
            searchGroupId={this.props.data.searchGroupId}
            linked={this.props.data.usedCount}
            viewed={this.props.data.viewCount}
            filters={this.props.filters}
            isportlet={true}
            fullscreen={this.props.fullscreen}
            objectClass={this.props.portlet.objectClass}
          />
        }
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings)
                .filter((o) => {
                  return this.props.portlet.objectClass ===
                    "com.kpsol.api.apicommon.history.SearchHistoryInterface"
                    ? o !== "settings_searchhistory_numberOfResults" &&
                        o !== "settings_searchhistory_userCount"
                    : true;
                })
                .map((setting, idx) => {
                  return <>{this.getSettingInfo(setting)}</>;
                })
            : this.state.defaultFullscreen
        }
        rowExpander={
          this.state.expanded ? (
            <ListSearchHistoryItems
              searchGroupId={this.props.data.searchGroupId}
              linked={this.props.data.usedCount}
              viewed={this.props.data.viewCount}
              filters={this.props.filters}
              isportlet={true}
              fullscreen={this.props.fullscreen}
              objectClass={this.props.portlet.objectClass}
            />
          ) : (
            <></>
          )
        }
        rowExpanderState={this.state.expanded}
      >
        {this.props.preText}
        {this.props.fullscreen ? (
          <Link
            id="search-history-link"
            component="button"
            color="inherit"
            underline="none"
            // classes={{ button: classes.buttontitle }}
            onClick={this.onItemClick}
          >
            {this.props.data.searchString}
          </Link>
        ) : (
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={this.primaryInfo()}
            secondary={this.state.secondaryString}
          />
        )}
      </KpsListItem>
    );
  }

  primaryInfo = () => {
    const { classes } = this.props;
    return (
      <div>
        <em>{this.props.data.searchString}</em>
        <span className={classes.iconSpan}>
          {this.props.data.usedCount > 0 && (
            <div>
              <Badge badgeContent={this.props.data.usedCount} color="primary">
                <LinkIcon />
              </Badge>
            </div>
          )}
          {/* {this.props.data.viewCount > 0 &&    
          <div>
            <Badge
              badgeContent={this.props.data.viewCount}
              color="secondary">
              <VisibilityIcon />
            </Badge>       
          </div>      
        } */}
        </span>
      </div>
    );
  };
  onItemClick = (e) => {
    let isExpanded = this.state.expanded;
    this.props.fullscreen
      ? this.setState({ expanded: !isExpanded })
      : this.props.history.push(`/search/${this.props.data.searchString}`);
  };
  returnSettingItem = (settings) => {
    const { theme, classes } = this.props;
    let fontWeight = {
      fontWeight: this.props.fullscreen ? "bold" : "normal",
      marginRight: theme.spacing(2),
    };

    return (
      <span>
        {settings === "settings_searchhistory_last_searched" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_searchhistory_last_searched")}
            </div>
            <div>{moment(this.props.data.lastSearchedDate).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_searchhistory_total" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_searchhistory_total")}
            </div>
            <div>{this.props.data.total}</div>
          </div>
        )}
        {settings === "settings_searchhistory_usedCount" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_searchhistory_usedCount")}
            </div>
            <div>{this.props.data.usedCount}</div>
          </div>
        )}
        {settings === "settings_searchhistory_viewCount" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_searchhistory_viewCount")}
            </div>
            <div>{this.props.data.viewCount}</div>
          </div>
        )}
        {this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
          settings === "settings_searchhistory_userCount" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_searchhistory_userCount")}
              </div>
              <div>{this.props.data.userCount}</div>
            </div>
          )}
        {this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
          settings === "settings_searchhistory_numberOfResults" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_searchhistory_numberOfResults")}
              </div>
              <div>{this.props.data.numberOfResults}</div>
            </div>
          )}
      </span>
    );
  };
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "settings_searchhistory_last_searched" && (
          <TableCell>
            {moment(this.props.data.lastSearchedDate).format(
              "DD/MM/YYYY HH:mm:ss"
            )}
          </TableCell>
        )}
        {setting.label === "settings_searchhistory_total" && (
          <TableCell>{this.props.data.total}</TableCell>
        )}
        {setting.label === "settings_searchhistory_usedCount" && (
          <TableCell>{this.props.data.usedCount}</TableCell>
        )}
        {setting.label === "settings_searchhistory_viewCount" && (
          <TableCell>{this.props.data.viewCount}</TableCell>
        )}
        {this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
          setting.label === "settings_searchhistory_userCount" && (
            <TableCell>{this.props.data.userCount}</TableCell>
          )}
        {this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
          setting.label === "settings_searchhistory_numberOfResults" && (
            <TableCell>{this.props.data.numberOfResults}</TableCell>
          )}
        {setting.label === "settings_searchhistory_searchString" && (
          <TableCell>{this.props.data.searchString}</TableCell>
        )}
      </>
    );
  };
  secondaryInfo(settings) {
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        if (this.props.expertQuestionOptions) {
          for (let i = 0; i < this.props.searchHistoryOptions.length; i++) {
            settings.push({
              label: this.props.expertQuestionOptions[i],
              order: i,
            });
          }
        }
      } else {
        if (!settings) {
          settings = JSON.parse(this.props.fullscreenSettings);
        } else {
          try {
            settings = JSON.parse(settings);
          } catch (x) {}
        }
      }
      this.setState({ secondaryString: "" });
    } else {
      if (this.props.secondaryInfo) {
        return this.props.secondaryInfo;
      }
      if (!settings) {
        settings = "settings_searchhistory_last_searched";
      }

      const { classes } = this.props;
      let info = (
        <>
          {this.props.fullscreen && settings ? (
            settings.map((setting) => {
              return this.returnSettingItem(setting);
            })
          ) : (
            <div>{this.returnSettingItem(settings)}</div>
          )}
        </>
      );
      this.setState({ secondaryString: info });
    }
  }
}

const mapStateToProps = (state) => ({
  searchHistoryOptions: state.selectionOption.searchHistorySettingsOptions,
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(withTheme(withStyles(styles)(withTranslation()(ItemSearches))))
);
